import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import "../../Products/CSS/product.css";
import placeholderImage from "../../../Components/Navbar/CSS/Assets/Banners/150x150.png";
import ProductQuickView from "../../Products/QuickViewPage";
import { useUserContext } from "../../Context/Context";

const Bestsellingproducts = () => {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const { addToCart, cart } = useUserContext();
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showQuickView, setShowQuickView] = useState(false);
  const [likedProducts, setLikedProducts] = useState([]);

  useEffect(() => {
    setLoading(true);

    const localData = localStorage.getItem("products");
    if (localData) {
      const parsedData = JSON.parse(localData);
      setProducts(parsedData);
      setFilteredProducts(parsedData);
      setLoading(false);
    } else {
      fetch("https://dehleze.shop/product-create/")
        .then((response) => response.json())
        .then((data) => {
          setProducts(data);
          setFilteredProducts(data);
          localStorage.setItem("products", JSON.stringify(data)); // Store in local storage
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching products:", error);
          setLoading(false);
          toast.error("Failed to load products. Please try again later.");
        });
    }
  }, []);

  useEffect(() => {
    setLoading(true);
    const searchParams = new URLSearchParams(location.search);
    const searchQuery = searchParams.get("search") || "";
    const categoryId = searchParams.get("category");

    let filtered = products.filter((product) => product.status === "Approved");

    if (categoryId) {
      filtered = filtered.filter(
        (product) =>
          product.category_Id && product.category_Id.toString() === categoryId
      );
    }

    if (searchQuery) {
      filtered = filtered.filter((product) =>
        product.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    setFilteredProducts(filtered);
    setLoading(false);
  }, [location.search, products]);

  const handleAddToCart = (product) => {
    if (product.stock === 0) {
      toast.error("Sorry, this product is out of stock!");
      return;
    }

    const exists = cart.some((item) => item.id === product.id);
    if (exists) {
      toast.warning("Product already exists in the cart!");
    } else {
      addToCart(product);
      toast.success("Product added to cart successfully!");
    }
  };

  const handleQuickView = (product) => {
    setSelectedProduct(product);
    setShowQuickView(true);
  };

  const calculateDiscountedPrice = (price, discountPercentage) => {
    const numericPrice = parseFloat(price);
    if (isNaN(numericPrice)) {
      return "N/A";
    }
    if (!discountPercentage || discountPercentage <= 0) {
      return numericPrice.toFixed(2);
    }
    const discountAmount = (numericPrice * discountPercentage) / 100;
    return (numericPrice - discountAmount).toFixed(2);
  };

  const capitalizeWords = (string) => {
    if (!string) return "";
    return string
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  return (
    <div className="Ccontainer bestsellingcontainer">
      <div className="productRightAcc ybestsellingAcc">
        <div className="products-container ybestsellingproduct mt-4">
          {loading ? (
            <div className="loading-spinner">
              <p>Loading products...</p>
            </div>
          ) : filteredProducts.length > 0 ? (
            filteredProducts.slice(0, 10).map((product) => (
              <div key={product.id} className="product-card ybestsellingcard">
                <div className="discount-product-badge">
                  {product?.discount_percentage > 0
                    ? `-${product.discount_percentage}%`
                    : "0%"}
                </div>

                <div className="product-image-container">
                  <img
                    src={
                      product?.product_image?.replace(
                        "http://39.61.51.195:8004/",
                        "https://dehleze.shop/"
                      ) ||
                      placeholderImage ||
                      product.color_image?.[0]?.replace(
                        "http://39.61.51.195:8004/",
                        "https://dehleze.shop/"
                      ) ||
                      product.images?.[0]?.image?.replace(
                        "http://39.61.51.195:8004/",
                        "https://dehleze.shop/"
                      )
                    }
                    alt="product"
                    className="product-image"
                  />
                  <div className="hover-icons">
                    <div
                      className="icon"
                      onClick={() => {
                        setLikedProducts((prev) =>
                          prev.includes(product.id)
                            ? prev.filter((id) => id !== product.id)
                            : [...prev, product.id]
                        );
                      }}
                    >
                      <i
                        className="fa fa-heart"
                        aria-hidden="true"
                        style={{
                          color: likedProducts.includes(product.id)
                            ? "red"
                            : "#333",
                        }}
                      ></i>
                    </div>

                    <div
                      className="icon"
                      onClick={() => handleAddToCart(product)}
                    >
                      <i className="fa fa-shopping-cart" aria-hidden="true"></i>
                    </div>
                    <div
                      className="icon"
                      onClick={() => handleQuickView(product)}
                    >
                      <i className="fa fa-eye" aria-hidden="true"></i>
                    </div>
                  </div>
                </div>
                <p
                  style={{
                    color: "black",
                    fontWeight: "15px",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    marginBottom: "0px",
                    marginTop: "5px",
                    padding: "5px",
                  }}
                >
                  <span className="h4-title">
                    {capitalizeWords(product.name)}
                  </span>
                </p>
                <p style={{ color: "#ff4444" }}>
                  <del>PK{product.price}</del>
                  <span>
                    {" "}
                    PK
                    {calculateDiscountedPrice(
                      product.price,
                      product.discount_percentage
                    )}
                  </span>
                </p>

                <Link
                  className="view-btn bestsellingbtn"
                  to={`/product-details/${product.id}`}
                >
                  View Details
                </Link>
              </div>
            ))
          ) : (
            <div className="out-of-stock">
              <h2>No Products Found</h2>
              <p>The product you are searching for is out of stock.</p>
            </div>
          )}
        </div>

        <ProductQuickView
          show={showQuickView}
          onHide={() => setShowQuickView(false)}
          product={selectedProduct}
        />
      </div>
    </div>
  );
};

export default Bestsellingproducts;
